import listeBonEntreeStock from '@/views/bonStock/l_bonEntreeStock';
import listeBonSortieStock from '@/views/bonStock/l_bonSortieStock';
import editionBonEntreeStock from '@/views/bonStock/m_bonEntreeStock';
import editionBonSortieStock from '@/views/bonStock/m_bonSortieStock';
import BonStock from '@/views/bonStock/c_bonStock';
import {
  EDITION_BON_ENTREE_ROUTE,
  EDITION_BON_SORTIE_ROUTE,
  LISTE_BON_ENTREE_ROUTE,
  LISTE_BON_SORTIE_ROUTE,
  DETAILS_BON_ENTREE_ROUTE,
  DETAILS_BON_SORTIE_ROUTE,
  DETAILS_BON_ENTREE_ROUTE_BY_LIGNE_COMMANDE_ID,
} from '@/configuration/bonStock/menuStockConf';

export default [
  {
    path: '/liste-bons-entree/',
    component: listeBonEntreeStock,
    name: LISTE_BON_ENTREE_ROUTE,
  },
  {
    path: '/liste-bons-sortie/',
    component: listeBonSortieStock,
    name: LISTE_BON_SORTIE_ROUTE,
  },
  {
    path: '/edition-bon-entree/:id?',
    component: editionBonEntreeStock,
    name: EDITION_BON_ENTREE_ROUTE,
  },
  {
    path: '/edition-bon-sortie/:id?',
    component: editionBonSortieStock,
    name: EDITION_BON_SORTIE_ROUTE,
  },
  {
    path: '/bon-entree/:id',
    component: BonStock,
    name: DETAILS_BON_ENTREE_ROUTE,
  },
  {
    path: '/bon-sortie/:id',
    component: BonStock,
    name: DETAILS_BON_SORTIE_ROUTE,
  },
  {
    path: '/bon-entree-ligne-commande/:ligneCommandeId',
    component: BonStock,
    name: DETAILS_BON_ENTREE_ROUTE_BY_LIGNE_COMMANDE_ID,
  },
];
